import {
  ALCOHOL_CANNABIS,
  BE_MATCHED,
  EVENT_ATTRACT,
  JOIN_HOST,
  SEXUAL_ENVIRONMENTS,
} from "@/enums/lifestyleEnums";

// src/app/constants.js
export const ROLES = Object.freeze({
  ADMIN: "admin",
  EDITOR: "editor",
  MEMBER: "member",
});

export const ACCOUNT_STATUS = Object.freeze({
  ACTIVE: "active",
  SUSPENDED: "suspended",
  BANNED: "banned",
  DELETED: "deleted",
});

export const MEMBER_PROGRESS = Object.freeze({
  LOCAL: "local",
  AVATAR: "avatar",
  GENDER: "gender",
  RELATION: "relation",
  SEXUAL_IDENTITY: "sexual_identity",
  SEXUAL_ROLE: "sexual_role",
  ATTRACTION_GENDERS: "attraction_genders",
  CONNECTION_TYPES: "connection_types",
  INTIMACY_TYPES: "intimacy_types",
  SEXUAL_FANTASIES: "sexual_fantasies",
  BODY_TYPE: "body_type",
  BODY_ATTRACT: "body_attract",
  SEXUAL_ENVIRONMENT: "sexual_environment",
  EVENT_ATTRACT: "event_attract",
  ALCOHOL_CANNABIS: "alcohol_cannabis",
  BE_MATCHED: "be_matched",
  JOIN_HOST: "join_host",
  REAL_IMAGE: "real_image",
  SOCIAL: "social",
  PAYMENT: "payment",
  PENDING: "pending",
  APPROVED: "approved",
});

export const PATHS = Object.freeze({
  LOGIN: "/login",

  // Account issue pages
  ACCOUNT_SUSPENDED: "/account/suspended",
  ACCOUNT_BANNED: "/account/banned",
  ACCOUNT_DELETED: "/account/deleted",

  // Staff dashboards
  ADMIN_HOME: "/admin",
  EDITOR_HOME: "/employee",

  // Member dashboards
  MEMBER_HOME: "/lounge",
  MEMBER_UNVERIFIED: "/member/unverified",

  // 🆕 Email verification page
  VERIFY_EMAIL: "/verify-email",

  // Member onboarding
  MEMBER_CREATE: "/member",
   MEMBER_CHOOSE_TYPE: "/member/citizenship",
  MEMBER_LOCAL: "/member/local",
  MEMBER_AVATAR: "/member/avatar",
  MEMBER_GENDER: "/member/gender",
  MEMBER_RELATION: "/member/relation",
  SEXUAL_IDENTITY: "/member/sexual_identity",
  SEXUAL_ROLE: "/member/sexual_role",
  ATTRACTION_GENDERS: "/member/attraction_genders",
  CONNECTION_TYPES: "/member/connection_types",
  INTIMACY_TYPES: "/member/intimacy_types",
  SEXUAL_FANTASIES: "/member/sexual_fantasies",
  BODY_TYPE: "/member/body_type",
  BODY_ATTRACT: "/member/body_attract",
  SEXUAL_ENVIRONMENT: "/member/sexual_environment",
  EVENT_ATTRACT: "/member/event_attract",
  ALCOHOL_CANNABIS: "/member/alcohol_cannabis",
  BE_MATCHED: "/member/be_matched",
  JOIN_HOST: "/member/join_host",
  REAL_IMAGE: "/member/real_image",
  SOCIAL: "/member/social",
  PAYMENT: "/member/payment",
  PENDING: "/member/pending",
  APPROVED: "/lounge",
});
